import { Box, Flex, rem, Skeleton, Stack, Text } from "@mantine/core";

// Moldura dos blocos (mesma do index): fundo/borda/raio via virtual colors.
const blockStyle = {
  background: "var(--mantine-color-background_3-0)",
  border: "1px solid var(--mantine-color-default-border)",
  borderRadius: rem(12),
} as const;

/**
 * Esqueleto dos valores do bloco "Plano atual". Mantém o rótulo fixo como
 * elemento real e esqueletiza apenas nome do plano, preço e status (do banco).
 */
export function PlanBlockSkeleton() {
  return (
    <Stack gap={rem(12)}>
      <Flex
        justify="space-between"
        align="flex-start"
        wrap="wrap"
        gap={rem(12)}>
        <Box>
          <Text
            fz={rem(12)}
            fw={700}
            c="dimmed"
            tt="uppercase"
            style={{ letterSpacing: "0.5px" }}>
            Plano atual
          </Text>
          <Skeleton
            h={rem(24)}
            w={rem(160)}
            radius="sm"
            mt={rem(6)}
          />
          <Skeleton
            h={rem(24)}
            w={rem(120)}
            radius="sm"
            mt={rem(8)}
          />
        </Box>
        <Skeleton
          h={rem(22)}
          w={rem(96)}
          radius="xl"
        />
      </Flex>
    </Stack>
  );
}

/**
 * Esqueleto dos valores do bloco "Forma de pagamento". O rótulo fixo fica no
 * index; aqui esqueletizamos apenas a linha do cartão (bandeira, final e botão),
 * carregada on-demand do Stripe.
 */
export function PaymentMethodBlockSkeleton() {
  return (
    <Flex
      align="center"
      gap={rem(12)}
      wrap="wrap">
      <Skeleton
        h={rem(40)}
        w={rem(40)}
        radius="md"
      />
      <Box style={{ flex: 1, minWidth: rem(220) }}>
        <Skeleton
          h={rem(16)}
          w={rem(140)}
          radius="sm"
        />
        <Skeleton
          h={rem(12)}
          w={rem(100)}
          radius="sm"
          mt={rem(6)}
        />
      </Box>
      <Skeleton
        h={rem(32)}
        w={rem(150)}
        radius="sm"
      />
    </Flex>
  );
}

/**
 * Esqueleto de carregamento completo da aba Faturamento. Renderiza os títulos e
 * molduras de seção fixos como elementos reais e esqueletiza apenas os valores
 * de plano e cartão. Disponível como fallback de carregamento da aba.
 */
export function BillingSettingsTabSkeleton() {
  return (
    <Stack gap={rem(20)}>
      {/* O título "Faturamento" vem do cabeçalho das Configurações. */}
      <Text
        fz={rem(13)}
        c="dimmed">
        Gerencie sua assinatura, cartão de pagamento e faturas.
      </Text>

      <Box
        p={rem(20)}
        style={blockStyle}>
        <PlanBlockSkeleton />
      </Box>

      <Box
        p={rem(20)}
        style={blockStyle}>
        <Stack gap={rem(14)}>
          <Text
            fz={rem(12)}
            fw={700}
            c="dimmed"
            tt="uppercase"
            style={{ letterSpacing: "0.5px" }}>
            Forma de pagamento
          </Text>
          <PaymentMethodBlockSkeleton />
        </Stack>
      </Box>
    </Stack>
  );
}

export default BillingSettingsTabSkeleton;
